import styled from "styled-components";

export const Heading = styled.h3<{ size?: "small" }>`
  margin-top: 0;
  font-weight: 600;
  text-align: center;
  margin-bottom: 16px;
  ${({ size }) => size === "small" && `font-size: 21px;`};
`;

export const Intro = styled.div`
  font-size: 15px;
  text-align: center;
  margin-bottom: 24px;
`;
